/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ElectricalSettingsComponent } from './electrical-settings.component';
export { ElectricalSettingsModule } from './electrical-settings.module';